import { useMutation } from '@tanstack/react-query'
import { client } from './api-client'

export const useLogin = () =>
  useMutation((data: unknown) =>
    client('auth/loginByEmail', {
      data,
    }),
  )
